
<template>
    <div class="body-panel dataContent">
        <template v-if="material != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back">
                            <router-link :to="'/materials/' + $route.params.id">Назад к материалу</router-link>
                        </p>
                    </div>
                </div>
            </div>

            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel page-content-block qwestions">
                    <div v-if="results != null">
                        <div class="test-result-header flex">
                            <div :class="['test-result-header-div', {'select': resultTabs.active === 'info'}]" @click="resultTabs.active='info'">Результаты теста</div>
                            <div v-if="material.TestDisplayRating" :class="['test-result-header-div', {'select': resultTabs.active === 'top'}]" @click="resultTabs.active='top'">ТОП-10</div>
                            <div v-if="material.TestDisplayStats" :class="['test-result-header-div', {'select': resultTabs.active === 'answers'}]" @click="resultTabs.active='answers'">Ваши ответы</div>
                        </div>
                        <div class="test-result-body">
                            <div :style="{display: resultTabs.active === 'info' ? 'block' : 'none'}">
                                <div class="test-result-body-header flex">
                                    <div class="test-result-body-icon">
                                        <svg class="svg-icon" v-if="results.Complete" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#ResultOk"></use>
                                        </svg>
                                        <svg class="svg-icon err" v-if="!results.Complete" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#ResultErr"></use>
                                        </svg>
                                    </div>
                                    <div class="test-result-body-text">
                                        <p class="caption-help">Тест завершён!</p>
                                        <p class="test-hello-text" v-if="!results.Complete">Вы не сдали тест</p>
                                        <p class="test-hello-text" v-if="results.Complete">Вы сдали тест</p>
                                    </div>
                                </div>
                                <div class="test-stats-row flex margin-top-30">
                                    <div class="test-stats-cell">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Time"></use>
                                        </svg>
                                        <p class="margin-top-10 caption-help">Время теста</p>
                                        <p class="margin-top-5 p-header-1">{{ results.TestTime }}</p>
                                    </div>
                                    <div class="test-stats-cell">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Hash"></use>
                                        </svg>
                                        <p class="margin-top-10 caption-help">Номер попытки</p>
                                        <p class="margin-top-5 p-header-1">{{ results.Attempt }}</p>
                                    </div>
                                </div>
                                <div class="test-stats-row flex">
                                    <div class="test-stats-cell">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Check"></use>
                                        </svg>
                                        <p class="margin-top-10 caption-help">Статистика ответов</p>
                                        <p class="margin-top-5 p-header-1"><span>{{ results.QuestionsRight }} ({{results.QuestionsRightPercent}}%)</span> / {{ results.QuestionsRight + results.QuestionsWrong}}</p>
                                    </div>
                                    <div class="test-stats-cell" v-if="material.Bonus > 0 || results.BonusMessage != null">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Star"></use>
                                        </svg>
                                        <p class="margin-top-10 caption-help">Итого баллов</p>
                                        <p class="margin-top-5 p-header-1">{{ results.BonusMessage == null ? results.Bonus : results.BonusMessage }}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="material.TestDisplayRating" :style="{display: resultTabs.active === 'top' ? 'block' : 'none'}">
                                <div class="test-result-body-header flex">
                                    <div class="test-result-body-icon">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Cup"></use>
                                        </svg>
                                    </div>
                                    <div class="test-result-body-text">
                                        <p class="caption-help">Топ-10 специалистов</p>
                                        <p class="test-hello-text">Лучшие из лучших</p>
                                    </div>
                                </div>
                                <table v-if="!isMobile" class="table-view">
                                    <thead>
                                        <tr class="heading">
                                            <th></th>
                                            <th>#</th>
                                            <th></th>
                                            <th align="left">ФИО</th>
                                            <th>Время теста</th>
                                            <th>Статистика ответов</th>
                                            <th>Итого баллов</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) of results.Top10">
                                            <td align="center" class="result-icon">
                                                <svg v-if="item.Place === 1" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg#gold-icon"></use>
                                                </svg>
                                                <svg v-if="item.Place === 2" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg#silver-icon"></use>
                                                </svg>
                                                <svg v-if="item.Place === 3" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg#bronze-icon"></use>
                                                </svg>
                                            </td>
                                            <td align="center">{{item.Place}}</td>
                                            <td class="img userimg" align="center" style="padding:5px">
                                                <img :src="'/uploads/users/' + item.UserImage" v-if="item.UserImage != null" />
                                                <img src="../../../img/u57.png" v-if="item.UserImage === null" />
                                            </td>
                                            <td>{{item.UserFio}}</td>
                                            <td align="center">{{item.TestTime}}</td>
                                            <td align="center">{{ formatAnswerStats(item.QuestionsRight, item.QuestionsWrong) }}</td>
                                            <td align="center">{{item.Bonus}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div v-if="isMobile" class="table-div" v-for="(item, i) of results.Top10">
                                    <div class="flex" style="font-size:14px;font-weight:600">
                                        <div class="result-icon">
                                            <svg v-if="item.Place === 1" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <use xlink:href="/Content/dist/image_svg.svg#gold-icon"></use>
                                            </svg>
                                            <svg v-if="item.Place === 2" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <use xlink:href="/Content/dist/image_svg.svg#silver-icon"></use>
                                            </svg>
                                            <svg v-if="item.Place === 3" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <use xlink:href="/Content/dist/image_svg.svg#bronze-icon"></use>
                                            </svg>
                                        </div>
                                        <div style="width:45px;min-width:45px">{{item.Place}}</div>
                                        <div style="width:100%;">{{item.UserFio}}</div>
                                    </div>
                                    <div class="flex margin-top-5 caption-help">
                                        <div style="width:50%">Время</div>
                                        <div style="width:50%;text-align:right">{{item.TestTime}}</div>
                                    </div>
                                    <div class="flex margin-top-2 caption-help">
                                        <div style="width:50%">Ответы</div>
                                        <div style="width:50%;text-align:right">{{ formatAnswerStats(item.QuestionsRight, item.QuestionsWrong) }}</div>
                                    </div>
                                    <div class="flex margin-top-2 caption-help">
                                        <div style="width:50%">Баллы</div>
                                        <div style="width:50%;text-align:right">{{item.Bonus}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="material.TestDisplayStats" :style="{display: resultTabs.active === 'answers' ? 'block' : 'none'}">
                                <div class="test-result-body-header flex">
                                    <div class="test-result-body-icon">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Qwestion"></use>
                                        </svg>
                                    </div>
                                    <div class="test-result-body-text">
                                        <p class="caption-help">Ваши ответы на вопросы</p>
                                        <p class="test-hello-text">Статистика ответов</p>
                                    </div>
                                </div>

                                <table v-if="!isMobile" class="table-view">
                                    <thead>
                                        <tr class="heading">
                                            <th>#</th>
                                            <th align="left">Вопрос</th>
                                            <th>Результат</th>
                                            <th>Время ответа</th>
                                            <th>Баллы</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) of results.Answers">
                                            <td align="center">{{ i + 1 }}</td>
                                            <td>{{item.QuestionDescription}}</td>
                                            <td align="center" :class="['qwestion-result', {'err': !item.Correct }]">{{item.Correct ? 'Верно': 'Не верно'}}</td>
                                            <td align="center">{{item.AnswerTime}}</td>
                                            <td align="center">{{item.Balance ? item.Balance.toFixed(0) : null }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="isMobile" class="table-div" v-for="(item, i) of results.Answers">
                                    <div class="flex caption-help">
                                        <div style="width:50%">Вопрос</div>
                                        <div style="width:50%;text-align:right"># {{ i + 1 }}</div>
                                    </div>
                                    <div class="margin-top-5" style="font-size:14px;font-weight:600">
                                        {{item.QuestionDescription}}
                                    </div>
                                    <div class="flex margin-top-5">
                                        <div style="width:50%">Результат</div>
                                        <div style="width:50%;text-align:right" :class="['qwestion-result', {'err': !item.Correct }]">{{item.Correct ? 'Верно': 'Не верно'}}</div>
                                    </div>
                                    <div class="flex margin-top-2">
                                        <div style="width:50%">Время ответа</div>
                                        <div style="width:50%;text-align:right">{{item.AnswerTime}}</div>
                                    </div>
                                    <div class="flex margin-top-2" v-if="item.Balance">
                                        <div style="width:50%">Баллы</div>
                                        <div style="width:50%;text-align:right">{{item.Balance.toFixed(0)}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>
        <vue-headful title="Результаты теста" />
    </div>
</template>


<script>
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    let backendApi = new BackendApi();

    export default {
        name: "material-testresults",

        props: ['info'],

        data() {
            return {
                material: null,
                results: null,
                resultTabs: {
                    active: 'info'
                },
                isMobile: UI.check_mobile()
            }
        },


        methods: {
            goToTest(){
                this.$router.push('/materials/' + this.material.Id + '/test');
            },

            formatAnswerStats(questionsRight, questionsWrong) {
                let count = questionsRight + questionsWrong;
                let questionsRightPercent = questionsRight * 100 / ( count === 0 ? 1: count);

                return questionsRight + ' (' + questionsRightPercent.toFixed(2) + '%) / ' + count;
            },

            loadMaterialTestResults() {
                let vm = this;
                let id = parseInt(this.$route.params.id);
                UI.blockUI('.login-page-bg', 'Загрузка...');

                return this.callApiWrapper(backendApi.materialLoadTestResults(id)).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке результатов теста');
                    }
                    else {
                        if (response.data == null) {
                            vm.$router.push('/materials');
                        }
                        else {
                            vm.results = response.data.Results;
                            vm.material = response.data.Material;

                            let totalAnswers = vm.results.QuestionsRight + vm.results.QuestionsWrong;
                            vm.results.QuestionsRightPercent = (vm.results.QuestionsRight * 100 / (totalAnswers > 0 ? totalAnswers : 1)).toFixed(2);
                        }
                    }
                    UI.unblockUI('.login-page-bg');
                })
            }
        },

        mounted() {

            this.loadMaterialTestResults();

            // для теста вёрстки

            // this.results = {
            //     Complete: true, // тест сдан
            //     QuestionsRightPercent: 33.33,
            //     QuestionsRight: 1,
            //     QuestionsWrong: 2,
            //     TestTime: '01:20',
            //     Attempt: 10,
            //     Bonus: 500,
            //     Rating: [
            //         { Fio: 'Fio - 1', TestTime: '1:23', StatsFormatted: '16 (100%) / 16', Bonus: 500},
            //         { Fio: 'Fio - 2', TestTime: '1:22', StatsFormatted: '16 (100%) / 16', Bonus: 400},
            //         { Fio: 'Fio - 3', TestTime: '1:21', StatsFormatted: '16 (100%) / 16', Bonus: 300},
            //         { Fio: 'Fio - 4', TestTime: '1:20', StatsFormatted: '16 (100%) / 16', Bonus: 200},
            //         { Fio: 'Fio - 5', TestTime: '1:19', StatsFormatted: '16 (100%) / 16', Bonus: 100}
            //     ],
            //     Answers: [
            //         { QuestionName: 'Вопрос-1', Correct: true, AnswerTime: '00:15' },
            //         { QuestionName: 'Вопрос-2', Correct: false, AnswerTime: '00:05' },
            //         { QuestionName: 'Вопрос-3', Correct: true, AnswerTime: '00:20' }
            //     ]
            // };
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/views/details/MaterialTestResults.vue